import { createSlice } from "@reduxjs/toolkit";

interface CounterState {
    socketObj: any,
    socketAuth: any,
    isConnected: boolean
}

const initialState: CounterState = {
    socketObj: null,
    socketAuth: null,
    isConnected: false
}

const socketSlice = createSlice({
    name: 'socket',
    initialState,
    reducers: {
        setSocket: (state, action) => {
            if(action.type == 'socket/setSocket'){
                state.socketObj = action.payload;
            }
        },
        setSocketAuth: (state, action) => {
            state.socketAuth = action.payload
        },
        setConnected: (state, action) => {
            state.isConnected = action.payload
        }
    }
});

export default socketSlice.reducer;
export const { setSocket, setSocketAuth, setConnected } = socketSlice.actions;
